export default __webpack_public_path__ + "static/media/src_img_9.d59aee95.jpg";